import CTable from "components/CTable";
import useAjax from "helpers/ajax";
import { getGridify, showError, useNewState } from "helpers/utility";
import useFilter from "components/Filter";
import { useEffect, useState } from "react";
import { filterTypes } from "components/Filter/constants";
import dayjs from "dayjs";
import { DEFAULT_PAGE_SIZE } from "constants";
import { useLocation } from "react-router-dom";

const RenewHisotry = () => {
  const { get } = useAjax();
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useNewState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [loading, setLoading] = useState(true);
  const {
    state: { licenseID },
  } = useLocation();

  const columns = [
    {
      title: "Authorization key",
      dataIndex: "authorizationKey",
      sorter: true,
      ...useFilter(),
    },
    {
      title: "Activated On",
      dataIndex: "activationDate",
      sorter: true,
      ...useFilter({ type: filterTypes.DATE }),
      render: (text) => (text ? dayjs(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Expired on",
      dataIndex: "expiredOn",
      sorter: true,
      ...useFilter({ type: filterTypes.DATE }),
      render: (text) => (text ? dayjs(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Renewed On",
      dataIndex: "renewedOn",
      sorter: true,
      ...useFilter({ type: filterTypes.DATE }),
      render: (text) => (text ? dayjs(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Days",
      dataIndex: "noOfDays",
      sorter: true,
      ...useFilter({ type: filterTypes.NUMBER }),
    },
    {
      title: "Expiring on",
      dataIndex: "expiringOn",
      sorter: true,
      ...useFilter({ type: filterTypes.DATE }),
      render: (text) => (text ? dayjs(text).format("MM/DD/YYYY") : ""),
    },
  ];

  const loadData = (pager, filters, sorter) => {
    const gridify = getGridify(pager, filters, sorter, [
      {
        field: "renewedOn",
        order: "descend",
      },
    ]);
    get("api/v1/licenses/renewhistory", {
      licenseID,
      ...gridify,
    })
      .then((resp) => {
        setData(resp.data);
        setPagination({
          ...pager,
          total: resp.count,
        });
      })
      .catch((err) => {
        showError(err);
      })
      .finally(() => setLoading(false));
  };

  const onTableChange = (pager, filters, sorter) => {
    loadData(pager, filters, sorter);
  };

  useEffect(() => {
    loadData(pagination);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CTable
      rowKey="historyID"
      columns={columns}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      onChange={onTableChange}
      scroll={{ x: "max-content" }}
    />
  );
};
export default RenewHisotry;
